import { render, staticRenderFns } from "./MirakunDevices.vue?vue&type=template&id=00bc295f&scoped=true&"
import script from "./MirakunDevices.vue?vue&type=script&lang=js&"
export * from "./MirakunDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bc295f",
  null
  
)

/* custom blocks */
import block0 from "./MirakunDevices.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00bc295f')) {
      api.createRecord('00bc295f', component.options)
    } else {
      api.reload('00bc295f', component.options)
    }
    module.hot.accept("./MirakunDevices.vue?vue&type=template&id=00bc295f&scoped=true&", function () {
      api.rerender('00bc295f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/MirakunDevices.vue"
export default component.exports